import React from 'react';
import {
  CheckedCheckbox,
  RadioCheckedIcon,
  RadioUncheckedIcon,
  UncheckedCheckbox,
} from '@commenda/icons';
import { cn } from '@commenda/utils';

const RadioCard = ({
  isActive = false,
  isCheckbox = false,
  heading,
  description,
  details,
  onClick,
  className = '',
  disabled = false,
}: {
  isActive?: boolean;
  isCheckbox?: boolean;
  heading: string;
  description?: string;
  details?: string[];
  onClick: () => void;
  className?: string;
  disabled?: boolean;
}) => {
  const Icon = isCheckbox
    ? isActive
      ? CheckedCheckbox
      : UncheckedCheckbox
    : isActive
    ? RadioCheckedIcon
    : RadioUncheckedIcon;
  return (
    <div
      className={cn(
        'p-4 rounded-xl border flex items-start gap-3 cursor-pointer hover:border-neutral-1 transition-all bg-neutral-7',
        isActive ? 'border-neutral-1' : 'border-stroke-2',
        disabled ? 'opacity-50 cursor-not-allowed bg-bg-disabled-subtle hover:border-stroke-2' : '',
        className
      )}
      onClick={disabled ? undefined : onClick}
    >
      <div className="mt-0.5">
        <Icon />
      </div>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <h5 className="text-neutral-1">{heading}</h5>
          {description ? (
            <p className="body-15-regular text-neutral-2">{description}</p>
          ) : null}
        </div>
        {details?.length ? (
          <ul className="flex flex-col gap-2 body-15-regular text-neutral-3 list-disc ml-4">
            {details.map((detail) => (
              <li>{detail}</li>
            ))}
          </ul>
        ) : null}
      </div>
    </div>
  );
};

export default RadioCard;
